import React, { useEffect, useMemo, useRef, useState } from 'react';
import classes from './SummaryPage.module.scss';
import CreateCampaignMain from 'pages/CreateCampaign/Components/Containers/MainContainer/MainContainer';
import Stepper from 'pages/CreateCampaign/Components/Stepper/Stepper';
import useRouter from 'hooks/useRouter';
import { Formik, Form } from 'formik';
import { Card, CardBody, CardHeader } from 'components/UI/Card';
import { useTheme, useMediaQuery, Box, TextField } from '@material-ui/core';
import Buttons from 'pages/CreateContribution/components/Buttons';
import ContentEditor from './Components/ContentEditor/ContentEditor';
import { SlimSwitch, StyledInput, SlimStyledSlider } from 'components/switch/style';
import Button from 'components/FormUI/Button';
import styled from 'styled-components';
import moment from 'moment';
import TimePickerField from 'components/FormUI/TimePickerField';
import DatePicker from './Components/DatePickerWithArrow/DatePickerWithArrow';
import Select from 'components/FormUI/Select';
import ArrowDownIcon from './Components/Icons/SVG/ArrowDownIcon';
import Modal from 'components/UI/Modal';
import { PhonePreviewVector, PhoneDesktop } from '../DesignPage/assests/SvgImages';
import useCampaign from 'pages/CreateCampaign/Hooks/useCampaign';
import { values } from 'lodash';
import Loader from 'components/UI/Loader';
import { createCampaignServices } from 'pages/CreateCampaign/Services/CreateCampaign.service';
import { useDispatch, useSelector } from 'react-redux';
import { saveCampaignToLS, setCampaignNotification, setSendEmailTo } from 'actions/campaign';
import { CampaignStatus } from 'pages/CreateCampaign/Constants/constants';
import * as Yup from 'yup';
import SelectedContacts from 'pages/Contacts/Clients/Clients';
import useNotifications from 'hooks/useNotifications';
import useAccount from 'hooks/useAccount';
import { editProfile, getProfile } from 'actions/user';
import { Tooltip } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import CommonErrorMessage from 'components/FormUI/CommonErrorMessage';

const StyledError = styled.div`
  color: red;
  margin-top: 5px;
`;
const emailRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;

const DummyTimeZones = [
  { title: 'Pacific Standard Time', value: 'PCT' },
  { title: 'Pacific Daylight Time', value: 'PDT' },
];

const Dummy_Template =
  '<!doctype html>\n<html>\n\t<head>\n\t</head>\n\t<body style="\n\t\tfont: 12px Tahoma, sans-serif;\n\t\tbackground-color: #e5e5e5;\n\t\tdisplay: flex;\n\t\theight: auto;\n\t\talign-items: center;\n\t\tposition: relative;\n\t\tflex-direction: column;">\n\t\t<table align="center" cellspacing=0>\n\t\t\t<tr>\n\t\t\t\t<td align="center" style="background-color: #ffffff;">\n\t\t\t\t\t<div style="\n\t\t\t\t\tpadding-top: 50px;\n\t\t\t\t\tpadding-bottom: 50px;">\n\t\t\t\t\t\t<img height="128" src="https://coherepublic-test.s3.amazonaws.com/626963f9381c7427157e4c3e/f46e486f-1209-451b-89a2-45d316ea6d2b.png">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td style="background-color: #ffffff;">\n\t\t\t\t\t<div style="padding: 50px;\n\t\t\t\t\tbackground-color: #0b6481;\n\t\t\t\t\tcolor: transparent">\n\t\t\t\t\t\t<h1 style="font-family: Roboto, sans-serif;\n\t\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\t\tfont-size: 45px;\n\t\t\t\t\t\tline-height: 45px;\n\t\t\t\t\t\ttext-align: center">\n\t\t\t\t\t\t\tCongrats on your Service!\n\t\t\t\t\t\t</h1>\n\t\t\t\t\t\t<h3 style="margin-top: 25px;\n\t\t\t\t\t\tfont-family: Roboto, sans-serif;\n\t\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\ttext-align: center">\n\t\t\t\t\t\t\tThis is an automated email to notify you that you have a new client!\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td style="background-color: #ffffff;">\n\t\t\t\t\t<div style="padding: 50px;">\n\t\t\t\t\t\t<h3 style="font-family: Roboto, sans-serif;\n\t\t\t\t\t\ttext-align: justify;\n\t\t\t\t\t\tcolor: #5c5c5c;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tfont-weight:300;\n\t\t\t\t\t\tline-height: 26px;">\n\t\t\t\t\t\t\tCongrats, {cohealerFirstName}! Your client {clientEmail} just enrolled into {contributionName} & paid {currencySymbol}{paidAmount} {currencyCode}.\n\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\tKeep up the great impact you\'re making!\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<h3 style="font-family: Roboto, sans-serif;\n\t\t\t\t\t\ttext-align: justify;\n\t\t\t\t\t\tcolor: #5c5c5c;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\tfont-weight:300;\n\t\t\t\t\t\tline-height: 26px;">\n\t\t\t\t\t\t\tBest wishes,<br>\n                            Team Cohere\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td align="center" style="background-color: #ffffff;"> \n\t\t\t\t\t<div style=" padding-top: 50px;\n\t\t\t\t\tpadding-bottom: 50px;">\n                        <a href="{loginLink}"\n                        style="padding: 12px 70px;\n\t\t\t\t\t\tbackground-color: #d1b989;\n\t\t\t\t\t\tfont-family: Roboto, sans-serif;\n\t\t\t\t\t\tfont-weight: 800;\n\t\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t\t\tletter-spacing: 3px;">Login</a>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>\n\t\t\t\t\t<p style="font-family: Roboto, sans-serif; color: #5c5c5c; font-size: 12px; line-height: 24px; text-align: center;">\n                        <a style="font: inherit; color: inherit; text-decoration: none;" href="{unsubscribeEmailLink}">Unsubscribe</a>\n                        |\n                        <a style="font: inherit; color: inherit; text-decoration: none;" href="mailto:support@cohere.live">Contact Support</a>\n                    </p>\n                </td>\n\t\t\t</tr>\n\t\t</table>\n\t</body>\n</html>';

const SummaryPage = () => {
  const theme = useTheme();
  const formRef = useRef();
  const { userContacts } = useSelector(state => state?.campaigns);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const { user } = useAccount();
  const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
  const [sendingTestEmail, setSendingTestEmail] = useState(false);
  const [isPhysicalAddressModalOpen, setIsPhysicalAddressModalOpen] = useState(false);
  const [physicalAddress, setPhysicalAddress] = useState('');
  const { successMessage } = useNotifications();
  const { history, query } = useRouter();
  const { timeZones } = useSelector(state => state?.timeZone);
  const isEditing = !!query?.id;
  const dispatch = useDispatch();
  const [showSelectedContacts, setShowSelectedContacts] = useState(false);
  const [testEmailAddress, setTestEmailAddress] = useState(user?.email);
  const [error, setError] = useState('');
  const [emailAddressError, setEmailAddressError] = useState(null);
  const [isTimePickerOpen, setIsTimePickerOpen] = useState(false);
  const [redirectTo, setRedirectTo] = useState(null);
  const [openCampaignPreview, setOpenCampaignPreview] = useState(false);
  const [pastTimeSelected, setPastTimeSelected] = useState(false);
  const [emailSentSuccessful, setEmailSuccessful] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);

  const [openPhonePreview, setPhonePreview] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { campaign, isCreateCampagnPage } = useCampaign();
  const date = moment(campaign?.scheduleDateTime);
  const time = moment(campaign?.scheduleDateTime);

  const campaignData = [
    {
      name: 'Campaign Title',
      value: campaign?.title || 'Test Campaign',
      to: 'title',
    },
    {
      name: 'Email Subject',
      value: campaign?.emailSubject || 'Early Bird Discounts',
      to: 'title',
    },
    {
      name: 'Preheader',
      value: campaign?.preHeaderText || '',
      to: 'title',
    },
    {
      name: 'From Name',
      value: campaign?.fromName || 'Paul Oran',
      to: 'title',
    },
    {
      name: 'Sending Address',
      value: campaign?.fromEmail || 'pauloran@gmail.com',
      to: 'title',
    },
    // {
    //   name: 'Contacts',
    //   value: 'Client list with segment The Cohere Academy Tag ',
    //   to: 'contacts',
    // },
    {
      name: 'Number of Contacts',
      value: campaign?.recipients?.length || '0',
      to: 'contacts',
    },
  ];
  const currentTime = moment();
  const nextHour = currentTime.add(1, 'hour').hour();
  useEffect(() => {
    if (campaign) {
      if (formRef?.current) {
        formRef.current.setFieldValue('isSechedule', campaign?.isSechedule || false);
        formRef.current.setFieldValue('scheduleTimeZone', campaign?.scheduleTimeZone || user?.timeZoneId);
        formRef.current.setFieldValue(
          'scheduleDate',
          campaign?.scheduleDateTime ? moment(campaign?.scheduleDateTime) : moment(new Date()),
        );
        formRef.current.setFieldValue(
          'scheduleTime',
          campaign?.scheduleDateTime
            ? moment(campaign?.scheduleDateTime)
            : moment.utc().set('hour', nextHour).set('minutes', 0).set('seconds', 0).set('milliseconds', 0),
        );
        setSelectedContacts(campaign?.recipients?.map(r => r?.userId));
      }
    }
  }, [campaign]);

  useEffect(() => {
    if (isCreateCampagnPage && campaign === null) {
      history.replace(`/create-campaign/title`);
    }
  }, [campaign]);

  const handleEmailChange = e => {
    const value = e.target.value;
    setTestEmailAddress(value);

    if (value.length === 0) {
      setEmailAddressError(null);
      return;
    }
    const isEmailCorrect = emailRegEx.test(value);
    if (!isEmailCorrect) {
      setEmailAddressError('Invalid email address');
    } else {
      setEmailAddressError(null);
    }
  };

  const saveAsDraft = (values, to) => {
    setIsLoading(true);
    const data = {
      ...campaign,
      ...values,
      scheduleDateTime: `${moment(values?.scheduleDate).format('YYYY-MM-DD')}T${moment(values?.scheduleTime).format(
        'HH:mm:ss',
      )}`,
    };

    delete data.scheduleDate;
    delete data.scheduleTime;

    createCampaignServices
      .updateApprovedCampaign(data)
      .then(res => {
        dispatch(saveCampaignToLS(res));
        history.push(to);
      })
      .catch(err => {
        setError(err?.response?.data || err?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const saveHandler = (values, to) => {
    setIsLoading(true);
    const data = {
      ...campaign,
      ...values,
      scheduleDateTime: `${moment(values?.scheduleDate).format('YYYY-MM-DD')}T${moment(values?.scheduleTime).format(
        'HH:mm:ss',
      )}`,
    };

    delete data.scheduleDate;
    delete data.scheduleTime;

    if (isEditing && campaign?.status === CampaignStatus.Approved) {
      createCampaignServices
        .updateApprovedCampaign(data)
        .then(res => {
          dispatch(saveCampaignToLS(res));
          history.replace(to || redirectTo);
        })
        .catch(err => {
          setError(err?.response?.data || err?.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      createCampaignServices
        .updateDraftCampaign(data)
        .then(res => {
          dispatch(saveCampaignToLS(res));
          history.replace(to || redirectTo);
        })
        .catch(err => {
          setError(err?.response?.data || err?.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const submitHandler = values => {
    setIsLoading(true);
    const data = {
      ...campaign,
      ...values,
      scheduleDateTime: `${moment(values?.scheduleDate).format('YYYY-MM-DD')}T${moment(values?.scheduleTime).format(
        'HH:mm:ss',
      )}`,
    };

    delete data.scheduleDate;
    delete data.scheduleTime;

    // if (data?.isSechedule === true && moment(data?.scheduleDateTime).isBefore(moment())) {
    //   setIsLoading(false);
    //   setPastTimeSelected(true);
    //   return;
    // }
    if (isEditing && campaign?.status === CampaignStatus.Approved) {
      createCampaignServices
        .updateApprovedCampaign(data)
        .then(res => {
          dispatch(saveCampaignToLS(res));
          history.push(redirectTo);
        })
        .catch(err => {
          setError(err?.response?.data || err?.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      createCampaignServices
        .submitDraftCampaign(data)
        .then(res => {
          dispatch(saveCampaignToLS(res));
          history.push(redirectTo);
          if (values?.isSechedule) {
            dispatch(
              setCampaignNotification({
                heading: 'One-Time-Email Campaign scheduled Successfully',
                message: `You have successfully scheduled an Email Campaign named as ${campaign?.title}. Email will be sent to the selected client(s) on set date`,
              }),
            );
            setTimeout(() => {
              dispatch(setCampaignNotification(''));
            }, 8000);
            // successMessage(
            //   `${campaign?.title} scheduled Successfully`,
            //   `You have successfully scheduled an Email Campaign named as ${campaign?.title}. Email will be sent to the selected client(s) on set date`,
            // );
          } else {
            dispatch(
              setCampaignNotification({
                heading: 'One-Time Email Campaign Created Successfully',
                message: `You have successfully created ${campaign?.title} One-Time-Email Campaign`,
              }),
            );
            setTimeout(() => {
              dispatch(setCampaignNotification(''));
            }, 8000);
            // successMessage(
            //   `${campaign?.title} Created Successfully`,
            //   `You have successfully created ${campaign?.title} One-Time-Email Campaign`,
            // );
          }
        })
        .catch(err => {
          setError(err?.response?.data || err?.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const handlePhysicalAddressChange = e => {
    const input = e.target.value;
    setPhysicalAddress(input);
  };

  const handleBackClick = e => {
    if (showSelectedContacts) {
      setShowSelectedContacts(false);
    } else {
      dispatch(setSendEmailTo(null));
      history.goBack();
      if (history.length === 1) {
        history.push('/dashboard');
      }
    }
  };
  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        isSechedule: campaign?.isSechedule || false,
        scheduleDate: campaign?.scheduleDateTime ? moment(campaign?.scheduleDateTime) : moment(new Date()),
        scheduleTime: campaign?.scheduleDateTime
          ? moment(campaign?.scheduleDateTime)
          : moment.utc().set('hour', nextHour).set('minutes', 0).set('seconds', 0).set('milliseconds', 0),
        scheduleTimeZone: campaign?.scheduleTimeZone || user?.timeZoneId,
      }}
      validationSchema={Yup.object().shape({
        isSechedule: Yup.boolean(),
        scheduleTimeZone: Yup.string(),
      })}
      onSubmit={submitHandler}
    >
      {({ values, setFieldValue, handleSubmit, errors }) => {
        return (
          <CreateCampaignMain
            headerProps={{
              handleBackClick,
            }}
          >
            {isLoading && <Loader />}
            {showSelectedContacts ? (
              <SelectedContacts
                showTopBar={false}
                showFilter={false}
                clients={[
                  ...userContacts?.clients?.filter(c => selectedContacts.includes(c.id)),
                  ...userContacts?.leads?.filter(l => selectedContacts.includes(l.id)),
                ]}
                setClients={setSelectedContacts}
                markedClients={selectedContacts}
                isReadOnlyView={true}
              />
            ) : (
              <>
                <Card id={'createCampaign'} mobileView={mobileView}>
                  <CardHeader mobileView={mobileView}>
                    <div className={classes.stepper_container}>
                      <Stepper
                        activeStep={4}
                        handleSubmit={({ to }) => {
                          setRedirectTo(to);
                          saveHandler(values, to);
                        }}
                      />
                    </div>
                  </CardHeader>
                  <CardBody className={classes.form_body} mobileView={mobileView}>
                    <div className={classes.form_container}>
                      <div className={classes.title_class}>Summary</div>
                      <div className={classes.summary_container}>
                        <div className={`${classes.summary_content} ${classes.summary_main}`}>
                          {campaignData?.map((item, index) => {
                            const isHoverAbleValueItem = item.name === 'Number of Contacts';
                            const onValueClick = () => {
                              setShowSelectedContacts(true);
                            };

                            return (
                              <ContentEditor
                                key={index}
                                attributeName={item?.name}
                                attributeValue={item?.value}
                                isValueHoverable={isHoverAbleValueItem}
                                onValueClick={isHoverAbleValueItem && onValueClick}
                                onEditClick={() => {
                                  history.push(
                                    isEditing
                                      ? `/edit-campaign/${query?.id}/${item?.to}`
                                      : `/create-campaign/${item?.to}`,
                                  );
                                }}
                              />
                            );
                          })}
                        </div>
                        <div className={`${classes.summary_content} ${classes.schedular}`}>
                          <div className={classes.schedule_email_container}>
                            <div className={classes.heading_container}>
                              <div className={classes.heading}>Do you want to schedule for later?</div>
                            </div>
                            <div className={classes.toggle_container}>
                              <div className={classes.toggle_text}>Turn toggle on to schedule this email</div>
                              <div className={classes.toggle_button_container}>
                                <SlimSwitch className={classes.toggle_button}>
                                  <StyledInput
                                    type="checkbox"
                                    onClick={() => {
                                      setFieldValue('isSechedule', !values?.isSechedule);
                                    }}
                                    checked={values?.isSechedule}
                                  />
                                  <SlimStyledSlider className="slider round" />
                                </SlimSwitch>
                              </div>
                            </div>
                            {values?.isSechedule && (
                              <div className={classes.time_date_schedule}>
                                <div
                                  onClick={() => {
                                    if (openDatePicker === false) {
                                      setOpenDatePicker(true);
                                    }
                                  }}
                                >
                                  <DatePicker
                                    value={values.scheduleDate}
                                    onChangeHandler={momentDate => {
                                      setFieldValue('scheduleDate', momentDate);
                                      setOpenDatePicker(false);
                                    }}
                                    setOpenDatePicker={setOpenDatePicker}
                                    openDatePicker={openDatePicker}
                                  />
                                </div>

                                <div
                                  onClick={() => {
                                    setIsTimePickerOpen(true);
                                  }}
                                  className={classes.time_picker_container}
                                >
                                  <TimePickerField
                                    open={isTimePickerOpen}
                                    onClose={() => {
                                      setIsTimePickerOpen(false);
                                    }}
                                    onChange={value => setFieldValue('scheduleTime', moment(value))}
                                    className={classes.time_picker}
                                    name="scheduleTime"
                                    classes={{
                                      root: 'mt-4 mr-3',
                                    }}
                                    showSecond={false}
                                    value={values.scheduleTime}
                                    format="h:mm a"
                                    use12Hours
                                    minuteStep={15}
                                  />
                                  <ArrowDownIcon
                                    onClickHandler={() => {
                                      setIsTimePickerOpen(true);
                                    }}
                                  />
                                </div>
                                <div className={classes.timezone_container}>
                                  <Select
                                    className={classes.timezone}
                                    name="scheduleTimeZone"
                                    onChange={e => {
                                      setFieldValue('scheduleTimeZone', e.target.value);
                                    }}
                                    classes={{
                                      root: classes.root_select,
                                      select: classes.select_select,
                                    }}
                                    inputProps={{
                                      classes: {
                                        input: classes.input_select,
                                      },
                                    }}
                                    InputProps={{
                                      classes: {
                                        input: classes.input_select,
                                      },
                                    }}
                                    fullWidth
                                    disableUnderline={true}
                                    items={timeZones?.map(t => ({ title: t.name, value: t.countryName }))}
                                    showHelperText={false}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                          <div className={classes.test_email_container}>
                            <div className={classes.heading_container}>
                              <div className={classes.heading}>Send a Test Email</div>
                            </div>
                            <div className={classes.action_container}>
                              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                <input
                                  className={classes.email_input}
                                  type="email"
                                  value={testEmailAddress}
                                  onChange={handleEmailChange}
                                />
                                {emailAddressError && <StyledError>{emailAddressError}</StyledError>}
                              </div>

                              <Button
                                onClick={() => {
                                  setSendingTestEmail(true);
                                  const data = {
                                    fromEmail: campaign?.fromEmail,
                                    fromName: campaign?.fromName,
                                    toEmail: testEmailAddress,
                                    htmlBody: campaign?.emailContent,
                                    subject: campaign?.emailSubject,
                                  };
                                  createCampaignServices
                                    .sendTestEmail(data)
                                    .then(res => {
                                      setSendingTestEmail(false);
                                      setEmailSuccessful(true);
                                    })
                                    .catch(error => {
                                      setSendingTestEmail(false);
                                    });
                                }}
                                className={classes.send_test_button}
                                autoWidth
                              >
                                Send Test
                              </Button>
                              <Button
                                className={classes.preview_button}
                                autoWidth
                                onClick={() => setOpenCampaignPreview(true)}
                              >
                                Preview
                              </Button>
                            </div>
                          </div>
                        </div>
                        {error?.length > 0 && <div className={classes.error}>Error: {error}!</div>}
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <Buttons
                  saveDraftButton={isEditing && campaign?.status === CampaignStatus.Approved ? false : true}
                  saveDraftButtonHandler={e => {
                    saveAsDraft(values);
                    history.push('/emails/campaigns');
                  }}
                  saveDraftButtonTitle={'Save as Draft'}
                  backButtonTitle="Back"
                  nextButtonTitle={values?.isSechedule ? 'Schedule Email' : 'Send Email Now'}
                  formId="create-campaign-form"
                  onNextClickHandler={e => {
                    if (!user?.address) {
                      setIsPhysicalAddressModalOpen(true);
                      return;
                    }
                    setRedirectTo('/emails/campaigns');
                    handleSubmit(e);
                  }}
                  backClickHandler={e => {
                    saveHandler(values);
                    history.replace(isEditing ? `/edit-campaign/${query?.id}/design` : '/create-campaign/design');
                  }}
                />
              </>
            )}

            <Modal
              disableConfirm={true}
              title="Campaign Preview "
              isOpen={openCampaignPreview}
              hiddenCancel
              onCancel={() => {
                setOpenCampaignPreview(false);
              }}
              widthRequired
            >
              <div className={classes.preview_conatiner}>
                <div className={classes.preview_btns}>
                  <div className={classes.image} onClick={() => setPhonePreview(true)}>
                    <PhonePreviewVector
                      fillBackgroundColor={openPhonePreview ? '#F1F8FF' : ''}
                      fillColor={openPhonePreview ? '#215C73' : ''}
                    />
                  </div>
                  <div className={classes.image} onClick={() => setPhonePreview(false)}>
                    <PhoneDesktop
                      fillBackgroundColor={!openPhonePreview ? '#F1F8FF' : ''}
                      fillColor={!openPhonePreview ? '#215C73' : ''}
                    />
                  </div>
                </div>
                <div className={classes.preview_body}>
                  <div
                    className={openPhonePreview ? classes.responsive_preview : classes.responsive_desktop_preview}
                    dangerouslySetInnerHTML={{ __html: campaign?.emailContent || Dummy_Template }}
                  ></div>
                </div>
              </div>
            </Modal>
            <Modal
              disableConfirm={false}
              title="Email Sent"
              isOpen={emailSentSuccessful}
              hiddenCancel
              onSubmit={() => {
                setEmailSuccessful(false);
              }}
              submitTitle="Ok"
              onCancel={() => {
                setEmailSuccessful(false);
              }}
              minHeight={'160px'}
            >
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Test email sent successfully.
              </div>
            </Modal>
            <Modal
              disableConfirm={false}
              title="Invalid Date/Time Selection"
              isOpen={pastTimeSelected}
              hiddenCancel
              widthRequired
              onSubmit={() => {
                setPastTimeSelected(false);
              }}
              submitTitle="Ok"
              onCancel={() => {
                setPastTimeSelected(false);
              }}
              minHeight={'160px'}
            >
              <div style={{ display: 'flex' }}>Please select a date and time in the future.</div>
            </Modal>

            <Modal
              isOpen={isPhysicalAddressModalOpen}
              title={
                <span>
                  Add your physical address{' '}
                  <Tooltip
                    title="Businesses must include a physical address in the footer of all email campaigns, as required by laws such as the CAN-SPAM Act in the United States. These laws aim to prevent the sending of unsolicited, fraudulent, or deceptive emails, promoting transparency and reducing spam."
                    arrow
                  >
                    <InfoIcon style={{ marginLeft: '8px', marginBottom: '3px' }} htmlColor="#C9B382" />
                  </Tooltip>
                </span>
              }
              submitTitle="Done"
              disableSubmitClick={physicalAddress?.length === 0}
              onSubmit={() => {
                if (physicalAddress?.length > 0) {
                  const data = {
                    ...user,
                    address: physicalAddress,
                  };
                  dispatch(editProfile(user?.id, data));
                  dispatch(getProfile(user?.id));
                  setIsPhysicalAddressModalOpen(false);
                }
              }}
              onCancel={() => {
                setPhysicalAddress('');
                setIsPhysicalAddressModalOpen(false);
              }}
              hiddenCancel
              widthRequired
            >
              <div className={classes.email_main_container}>
                <TextField
                  className={classes.email_main}
                  placeholder="Please enter your physical address"
                  variant="outlined"
                  value={physicalAddress}
                  onChange={handlePhysicalAddressChange}
                  helperText={
                    physicalAddress?.length === 0 ? (
                      <div style={{ color: 'red', marginTop: '5px', marginBottom: '5px', marginLeft: '-14px' }}>
                        <CommonErrorMessage message="Required" align="left" />
                      </div>
                    ) : (
                      ''
                    )
                  }
                  InputProps={{
                    classes: {
                      root: classes.email_root,
                      notchedOutline: classes.email_notchedOutline,
                    },
                  }}
                />
              </div>
            </Modal>
          </CreateCampaignMain>
        );
      }}
    </Formik>
  );
};

export default SummaryPage;
